import { get, post, put } from '..'
import {
    ArtMailInfo,
    CreateArtMailInfoPayload
} from '@/models/enrolls/artMailInfo'
import { createUploadHanlder } from './files'

export async function fetchArtStudentEnroll() {
  const { data } = await get(`student/ArtMailInfo/self`)
  return data as ArtMailInfo
}

export async function updateArtStudentEnroll(form: ArtMailInfo) {
  const { data } = await put(`student/ArtMailInfo/self`, form)
  return data as ArtMailInfo
}

export async function createArtStudentEnroll(form: CreateArtMailInfoPayload) {
  const { data } = await post(`student/ArtMailInfo/self`, form)
  return data as ArtMailInfo
}


/**
 * 上传文件
 * @param file 文件
 * @param onUploadProgress 监听进度
 * @returns 文件路径
 */
 export const uploadMailInflFile = createUploadHanlder(
    `student/ArtMailInfo/files`
  )